import axios from 'axios';
import { BASE_URL, FRONTEND_URL } from "../../config/axios";
import React, { useState, useEffect } from 'react';
import { formatDate } from '../Date';
import Loader from "../Loader";
import { Calender, OfficeBagIcon } from '../AllSvg';

// const JobInformation = () => {
//     const [alljobopenings, setAlljobopenings] = useState([]);
//     const [buffer, setBuffering] = useState(true);

//     const getAlljobopenings = async () => {
//         setBuffering(true); // Start Buffering
//         try {
//             const res = await axios.get(`${BASE_URL}/jd/jobpostfilter/active/${sessionStorage.getItem("company_id")}/`);
//             setAlljobopenings(res.data);
//         } catch (err) {
//             console.error(err.message);
//         } finally {
//             setBuffering(false);// End Buffering
//         }
//     };

//     useEffect(() => {
//         getAlljobopenings();
//     }, []);

//     return (
//         <div className='backgroundmain-task dashboard-card-emp'>
//             <div className='dashboardcomponent-task width-40vw'>

//                 {buffer ?
//                     <Loader container={true} />
//                     :
//                     <div className=" EmployeeDashboad-notification-cards d-flex-wrap" style={{ height: '282px' }}>
//                         {alljobopenings.map((data, index) => {
//                             return (
//                                 <>
//                                     <div className=' EmployeeDashboad-notification-card dashcomp-bg-card-style  field-cont-between'>
//                                         <div className=' field-cont-div'>
//                                             <div className=" ">
//                                                 <h3 className='dashcomp-announcement-heading  font-weight500    font-size-subheading  '>{data.position_name}</h3>
//                                                 <span className="dashcomp-announcement-date   font-weight500   font-size-subheading  ">
//                                                     {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className='dashcomp-announcement-date-svg'>
//                                                         <rect x="2.66602" y="3.3335" width="10.6667" height="10.6667" rx="2" stroke="#2576BC" stroke-width="2" />
//                                                         <path d="M10.666 1.3335L10.666 3.3335C10.666 4.2763 10.666 4.74771 10.3731 5.0406C10.0802 5.33349 9.60882 5.33349 8.66602 5.33349L7.33268 5.33349C6.38987 5.3335 5.91847 5.3335 5.62558 5.0406C5.33268 4.74771 5.33268 4.2763 5.33268 3.33349L5.33268 1.3335" stroke="#2576BC" stroke-width="2" stroke-linecap="round" />
//                                                         <path d="M6 9.3335L10 9.3335" stroke="black" stroke-width="2" stroke-linecap="round" />
//                                                     </svg> */}
//                                                     <Calender />{" "}
//                                                     {formatDate(data.start_date)} - {formatDate(data.end_date)}
//                                                 </span>
//                                                 <br />
//                                                 <div className='flex-jobcard-items'>
//                                                     <div className='new-flex'>
//                                                         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" id="work">
//                                                             <path fill="none" d="M0 0h24v24H0Z"></path>
//                                                             <path fill="#525863" d="M19.8 7.2h-3.6V5.4a1.8 1.8 0 0 0-1.8-1.8H9.6a1.8 1.8 0 0 0-1.8 1.8v1.8H4.2A1.8 1.8 0 0 0 2.4 9v9.6a1.8 1.8 0 0 0 1.8 1.8h15.6a1.8 1.8 0 0 0 1.8-1.8V9a1.8 1.8 0 0 0-1.8-1.8ZM9.6 5.4h4.8v1.8H9.6Zm10.2 13.2H4.2V9h15.6Z"></path>
//                                                         </svg>
//                                                         <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.experience}
//                                                         </p>
//                                                     </div>
//                                                     <div className='new-flex'>
//                                                         <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 32 32" id="workdesk">
//                                                             <path d="M18.5,4h4a.5.5,0,0,0,0-1h-4a.5.5,0,0,0,0,1Zm13,13H26.994a1.452,1.452,0,0,0,.1-.334l.9-8.11A.5.5,0,0,0,27.5,8H26.367a1.507,1.507,0,0,0-1.485,1.288L24.066,15H18.5A1.5,1.5,0,0,0,17,16.5V17H15.722A1.992,1.992,0,0,0,14,14H11.427L8.36,11.548A2.488,2.488,0,0,0,8,11.309V9.5a.472.472,0,0,0-.01-.051A3.941,3.941,0,0,0,9.616,4.318c-.007-.012-.012-.026-.02-.037A3.987,3.987,0,1,0,2.388,7.69l.009.017A4,4,0,0,0,4.01,9.449.472.472,0,0,0,4,9.5v1.551A2.5,2.5,0,0,0,2,13.5V24H1V16.5a.5.5,0,0,0-1,0v15a.5.5,0,0,0,1,0V25H7v6.5a.5.5,0,0,0,1,0V25H9v5a2,2,0,0,0,4,0V22.32a1.5,1.5,0,0,0-1.206-1.471l-1.811-.362A.477.477,0,0,0,10,20.4V17.75l.2.15a.5.5,0,0,0,.3.1H15V31.5a.5.5,0,0,0,1,0V20H29V31.5a.5.5,0,0,0,1,0V18h1.5a.5.5,0,0,0,0-1ZM3,6A2.991,2.991,0,0,1,8.4,4.217l-4,.793A.5.5,0,0,0,4,5.5V7H3.184A2.965,2.965,0,0,1,3,6Zm.78,2H4.5A.5.5,0,0,0,5,7.5V5.911l3.861-.766A2.959,2.959,0,0,1,9,6,2.989,2.989,0,0,1,3.78,8ZM7,9.858v1.159C6.933,11.012,6.866,11,6.8,11H5V9.858A3.954,3.954,0,0,0,6,10,3.954,3.954,0,0,0,7,9.858ZM11.6,21.83a.5.5,0,0,1,.4.49V30a1,1,0,0,1-2,0V24.5a.5.5,0,0,0-.5-.5H3V20.11ZM13,17H10.667L6.8,14.1a.5.5,0,1,0-.6.8L9,17H9v3.29l-6-1.2V13.5A1.5,1.5,0,0,1,4.5,12H6.8a1.5,1.5,0,0,1,.937.329l3.2,2.563a.5.5,0,0,0,.313.109H13Zm1,0V15h0a1,1,0,0,1,0,2Zm4-.5a.5.5,0,0,1,.5-.5h6a.5.5,0,0,0,.5-.429l.877-6.142a.5.5,0,0,1,.5-.429h.574l-.84,7.556a.5.5,0,0,1-.5.444H18ZM29,19H16V18H29ZM16.5,7h2.672l1.475,1.475A.5.5,0,0,0,21,8.621a.513.513,0,0,0,.1-.011.5.5,0,0,0,.362-.311l.5-1.3H24.5A1.5,1.5,0,0,0,26,5.5v-4A1.5,1.5,0,0,0,24.5,0h-8A1.5,1.5,0,0,0,15,1.5v4A1.5,1.5,0,0,0,16.5,7ZM16,1.5a.5.5,0,0,1,.5-.5h8a.5.5,0,0,1,.5.5v4a.5.5,0,0,1-.5.5H21.621a.5.5,0,0,0-.467.321l-.346.9L19.732,6.146A.5.5,0,0,0,19.379,6H16.5a.5.5,0,0,1-.5-.5Z"></path>
//                                                         </svg>
//                                                         <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.job_type}
//                                                         </p>
//                                                     </div>
//                                                     <div className='new-flex'>
//                                                         <svg width="24" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                                             <path d="M22 11.0857V12.0057C21.9988 14.1621 21.3005 16.2604 20.0093 17.9875C18.7182 19.7147 16.9033 20.9782 14.8354 21.5896C12.7674 22.201 10.5573 22.1276 8.53447 21.3803C6.51168 20.633 4.78465 19.2518 3.61096 17.4428C2.43727 15.6338 1.87979 13.4938 2.02168 11.342C2.16356 9.19029 2.99721 7.14205 4.39828 5.5028C5.79935 3.86354 7.69279 2.72111 9.79619 2.24587C11.8996 1.77063 14.1003 1.98806 16.07 2.86572M22 4L12 14.01L9 11.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
//                                                         </svg>
//                                                         <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.status}
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                                 <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.location}</p>
//                                                 <div className="dashcomp-announcement-p font-weight400  font-size-text">{data.description}</div>
//                                             </div>
//                                         </div>
//                                         <div className=' field-cont-div'>
//                                             <button
//                                                 onClick={() => {
//                                                     navigator.clipboard.writeText(
//                                                         `${FRONTEND_URL}/personaldetails/${data.id}/`
//                                                     );
//                                                     const notification = document.createElement("div");
//                                                     notification.classList.add("notification");
//                                                     notification.textContent =
//                                                         "Link copied to clipboard!";
//                                                     document.body.appendChild(notification);
//                                                     setTimeout(() => {
//                                                         document.body.removeChild(notification);
//                                                     }, 2000); // Remove notification after 2 seconds
//                                                 }}
//                                                 title="Click to Copy Form link"
//                                                 className="Color-tag-active-job"
//                                             >
//                                                 Get Link
//                                             </button>
//                                         </div>
//                                     </div>
//                                 </>
//                             )
//                         })
//                         }
//                     </div>}
//             </div>
//         </div>
//     );
// };

// export default JobInformation;



const JobInformation = () => {
    const [alljobopenings, setAlljobopenings] = useState([]);
    const [buffer, setBuffering] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);

    const getAlljobopenings = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(`${BASE_URL}/jd/jobpostfilter/active/${sessionStorage.getItem("company_id")}/`);
            setAlljobopenings(res.data);
        } catch (err) {
            console.error(err.message);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getAlljobopenings();
    }, []);

    const visibleCount = 2;
    const totalPages = Math.ceil(alljobopenings.length / visibleCount);
    const maxDots = 2;

    const handlePrev = () => setCurrentIndex(i => Math.max(0, i - 1));
    const handleNext = () => setCurrentIndex(i => Math.min(totalPages - 1, i + 1));

    const getDotsConfig = () => {
        if (totalPages <= maxDots) return Array.from({ length: totalPages }, (_, i) => i);
        if (currentIndex === 0) return [0, 1];
        if (currentIndex >= totalPages - 1) return [totalPages - 2, totalPages - 1];
        return [currentIndex - 1, currentIndex];
    };

    const visibleJobs = alljobopenings.slice(
        currentIndex * visibleCount,
        currentIndex * visibleCount + visibleCount
    );

    // Define SVG icons map - keyword based
    const JOB_ICON_MAP = [
        {
            keywords: ['frontend', 'front-end', 'ui', 'react', 'angular', 'vue'],
            svg: (color) => (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M4 6l4 6-4 6h2l3-4.5L12 18h2l-4-6 4-6h-2l-3 4.5L6 6H4z" fill={color} />
                    <path d="M14 6l4 6-4 6h2l4-6-4-6h-2z" fill={color} opacity="0.5" />
                </svg>
            )
        },
        {
            keywords: ['backend', 'back-end', 'node', 'python', 'java', 'api', 'server'],
            svg: (color) => (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <rect x="2" y="3" width="20" height="14" rx="2" stroke={color} strokeWidth="2" />
                    <path d="M8 21h8M12 17v4" stroke={color} strokeWidth="2" strokeLinecap="round" />
                    <path d="M7 8l3 3-3 3M13 14h4" stroke={color} strokeWidth="2" strokeLinecap="round" />
                </svg>
            )
        },
        {
            keywords: ['design', 'designer', 'ux', 'graphic', 'creative', 'visual'],
            svg: (color) => (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M12 19l7-7 3 3-7 7-3-3z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M2 2l7.586 7.586" stroke={color} strokeWidth="2" strokeLinecap="round" />
                    <circle cx="11" cy="11" r="2" stroke={color} strokeWidth="2" />
                </svg>
            )
        },
        {
            keywords: ['manager', 'management', 'project', 'lead', 'head', 'director', 'vp'],
            svg: (color) => (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="7" r="3" stroke={color} strokeWidth="2" />
                    <path d="M5 21v-2a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v2" stroke={color} strokeWidth="2" strokeLinecap="round" />
                    <path d="M16 3.5C17.5 4.5 18 6 17.5 7.5M19 2c2 1.5 2.5 4 1.5 6" stroke={color} strokeWidth="2" strokeLinecap="round" />
                </svg>
            )
        },
        {
            keywords: ['data', 'analyst', 'analytics', 'bi', 'report', 'dashboard'],
            svg: (color) => (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M3 3v18h18" stroke={color} strokeWidth="2" strokeLinecap="round" />
                    <path d="M7 16l4-5 4 3 4-6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            )
        },
        {
            keywords: ['hr', 'human resource', 'recruit', 'talent', 'people'],
            svg: (color) => (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <circle cx="9" cy="7" r="3" stroke={color} strokeWidth="2" />
                    <path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" stroke={color} strokeWidth="2" strokeLinecap="round" />
                    <path d="M16 11l2 2 4-4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            )
        },
        {
            keywords: ['sales', 'marketing', 'growth', 'business', 'executive'],
            svg: (color) => (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M22 12h-4l-3 9L9 3l-3 9H2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            )
        },
        {
            keywords: ['devops', 'cloud', 'infrastructure', 'security', 'network', 'sre'],
            svg: (color) => (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M18 10a6 6 0 0 0-12 0c0 .34.03.67.08 1A4 4 0 0 0 8 19h9a5 5 0 0 0 1-9.9V10z" stroke={color} strokeWidth="2" strokeLinecap="round" />
                </svg>
            )
        },
    ];

    // Fallback icon for unknown profiles
    const FALLBACK_ICON = (color) => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <rect x="2" y="7" width="20" height="14" rx="2" stroke={color} strokeWidth="2" />
            <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" stroke={color} strokeWidth="2" strokeLinecap="round" />
            <path d="M12 12v4M10 14h4" stroke={color} strokeWidth="2" strokeLinecap="round" />
        </svg>
    );

    // Resolver function
    const getJobIcon = (positionName = '') => {
        const name = positionName.toLowerCase();
        const match = JOB_ICON_MAP.find(({ keywords }) =>
            keywords.some(kw => name.includes(kw))
        );
        return match ? match.svg : FALLBACK_ICON;
    };


    const iconColors = { bg: 'rgb(216, 233, 255)', color: 'rgb(37, 118, 188)' };

    return (
        <div className="db2-card" style={{ position: 'relative' }}>

            {buffer ? (
                <Loader container={true} />
            ) : alljobopenings.length === 0 ? (
                <div className="db2-empty-state">
                    <div className="db2-empty-illus"><OfficeBagIcon /></div>
                    <div className="db2-empty-title">No job openings at the moment</div>
                </div>
            ) : (
                <>
                    {/* 2-column grid */}
                    <div
                        className='job-info-card'>
                        {visibleJobs.map((data, index) => {
                            // const colorIndex = (currentIndex * visibleCount + index) % iconColors.length;
                            // const iconIndex = (currentIndex * visibleCount + index) % jobIcons.length;
                            const IconSvg = getJobIcon(data.position_name);
                            const { bg, color } = iconColors;

                            return (
                                <div key={data.id || index} style={{
                                    border: '1px solid #eef0f5',
                                    borderRadius: '12px',
                                    padding: '14px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '8px',
                                    background: '#f9fbff',
                                }}>
                                    {/* Icon */}
                                    <div style={{
                                        width: '36px', height: '36px',
                                        borderRadius: '10px', background: bg,
                                        display: 'flex', alignItems: 'center',
                                        justifyContent: 'center', fontSize: '16px',
                                        marginBottom: '2px'
                                    }}>
                                        {/* {jobIcons[iconIndex]} */}
                                        {IconSvg(color)}
                                    </div>

                                    {/* Title */}
                                    <div style={{ fontSize: '14px', fontWeight: 600, color: '#1e293b' }}>
                                        {data.position_name}
                                    </div>

                                    {/* Date */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '11px', color: '#64748b' }}>
                                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
                                            <rect x="3" y="4" width="18" height="18" rx="2" stroke="#555b63" strokeWidth="2" />
                                            <path d="M16 2v4M8 2v4M3 10h18" stroke="#555b63" strokeWidth="2" strokeLinecap="round" />
                                        </svg>
                                        {formatDate(data.start_date)} – {formatDate(data.end_date)}
                                    </div>

                                    {/* Meta items */}
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                                        {/* Experience */}
                                        {data.experience && (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '3px', fontSize: '11px', color: '#64748b' }}>
                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                                                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke="#555b63" strokeWidth="2" strokeLinecap="round" />
                                                </svg>
                                                {data.experience}
                                            </div>
                                        )}

                                        {/* Job type */}
                                        {data.job_type && (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '3px', fontSize: '11px', color: '#64748b' }}>
                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                                                    <path d="M20 7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM16 3H8a2 2 0 0 0-2 2v2h12V5a2 2 0 0 0-2-2z" stroke="#555b63" strokeWidth="2" strokeLinecap="round" />
                                                </svg>
                                                {data.job_type}
                                            </div>
                                        )}


                                    </div>

                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                                        {/* Location */}
                                        {data.location && (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '3px', fontSize: '11px', color: '#64748b' }}>
                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                                                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" stroke="#555b63" strokeWidth="2" strokeLinecap="round" />
                                                </svg>
                                                {data.location}
                                            </div>
                                        )}
                                        {/* <div className="dashcomp-announcement-p font-weight400  font-size-text">{data.description}</div> */}
                                        {/* Status */}
                                        {data.status && (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '3px', fontSize: '11px', color: '#16a34a' }}>
                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                                                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14M22 4L12 14.01l-3-3" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" />
                                                </svg>
                                                {data.status}
                                            </div>
                                        )}
                                    </div>

                                    {/* Vacancies */}
                                    {data.vacancies && (
                                        <div style={{ fontSize: '12px', fontWeight: 600, color: '#ea580c' }}>
                                            Vacancies: {data.vacancies}
                                        </div>
                                    )}

                                    {/* Actions — Get Link + Copy */}
                                    <div style={{ display: 'flex', gap: '10px', marginTop: '2px' }}>
                                        <button
                                            onClick={() => {
                                                navigator.clipboard.writeText(
                                                    `${FRONTEND_URL}/personaldetails/${data.id}/`
                                                );
                                                const notification = document.createElement("div");
                                                notification.classList.add("notification");
                                                notification.textContent = "Link copied to clipboard!";
                                                document.body.appendChild(notification);
                                                setTimeout(() => {
                                                    document.body.removeChild(notification);
                                                }, 2000);
                                            }}
                                            title="Click to Copy Form link"
                                            className='employee-share-btn'

                                        >
                                            Get Link
                                        </button>
                                        <button
                                            onClick={() => {
                                                navigator.clipboard.writeText(
                                                    `${FRONTEND_URL}/personaldetails/${data.id}/`
                                                );
                                            }}
                                            title="Copy link"
                                            className='dashboard-copy-link-btn'
                                        >
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" stroke="#64748b" strokeWidth="2" strokeLinecap="round" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            );
                        })}

                        {/* Fill empty slot if odd */}
                        {visibleJobs.length === 1 && <div />}
                    </div>

                    {/* Prev arrow */}
                    {currentIndex > 0 && (
                        <button onClick={handlePrev} className="carousel-arrow carousel-arrow-prev">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                                <path d="M15 18l-6-6 6-6" stroke="#64748b" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                        </button>
                    )}

                    {/* Next arrow */}
                    {currentIndex < totalPages - 1 && (
                        <button onClick={handleNext} className="carousel-arrow carousel-arrow-next">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                                <path d="M9 18l6-6-6-6" stroke="#64748b" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                        </button>
                    )}

                    {/* Max 2 dots */}
                    {totalPages > 1 && (
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '6px', marginTop: '12px' }}>
                            {getDotsConfig().map((pageIndex) => (
                                <div
                                    key={pageIndex}
                                    onClick={() => setCurrentIndex(pageIndex)}
                                    style={{
                                        width: '7px', height: '7px', borderRadius: '50%',
                                        background: pageIndex === currentIndex ? 'rgb(21 118 202)' : '#e2e8f0',
                                        cursor: 'pointer', transition: 'background 0.15s'
                                    }}
                                />
                            ))}
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default JobInformation;